import * as angular from 'angular';

enum FinishPageState {
    CONFIRMATION_TIMEOUT,
    CONFIRMATION_REJECTED,
    CONFIRMATION_ACCEPTED
}

class LngFcfsOfferFinishComponentCtrl implements ng.IController {
    public pageStateEnum = FinishPageState;
    public state: FinishPageState;

    constructor(private $window: ng.IWindowService) {}

    $onInit() {}

    public newBooking(): void {
        this.$window.location.reload();
    }
}

angular.module('app').component('pkpLngFcfsOfferFinish', {
    controller: LngFcfsOfferFinishComponentCtrl,
    template: require('app/lng-booking-wizard/lng-fcfs-offer-finish.component.html'),
    bindings: {
        offer: '=',
        response: '=',
        attachmentList: '=',
        ssoName: '=',
        state: '='
    }
});
